export const BacksplashIcon = ({ ...props }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		className="lucide lucide-backsplash-icon"
		{...props}
	>
		{/* Backsplash rectangle - tall and wide */}
		<rect x="4" y="4" width="16" height="12" rx="1" />
		{/* Countertop surface line below */}
		<line x1="2" y1="20" x2="22" y2="20" strokeWidth="3" />
	</svg>
);
